import Navigation from './Navigation';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <main className="main" style={{ backgroundColor: 'white' }} id="top">
      <Navigation />
      <div className="content">{children}</div>
      <Footer />
    </main>
  );
};

export default Layout;
